module.exports = __webpack_public_path__ + "img/running.0a737d6.svg";